function addCopyrightCheckboxClickListeners() {
	const copyrightYearsSelectAllCheckbox = document.querySelector('#all-springer-books');
	const copyrightYearsCheckboxes = document.querySelectorAll('.c-copyright-years__checkbox');

	if (copyrightYearsSelectAllCheckbox && copyrightYearsCheckboxes !== null) {
		onClickListenerCheckboxes(copyrightYearsCheckboxes, 'copyright-years', copyrightYearsSelectAllCheckbox);
		copyrightYearsSelectAllCheckbox.addEventListener('click', () => {
			checkAll(copyrightYearsSelectAllCheckbox, copyrightYearsCheckboxes);
		});
	}
}

function addBookArchivesCheckboxClickListeners() {
	const bookArchivesSelectAllCheckbox = document.querySelector('#sba-all-springer-book-archives');
	const bookArchivesCheckboxes = document.querySelectorAll('.c-copyright-years--book-archives__checkbox');

	if (bookArchivesSelectAllCheckbox && bookArchivesCheckboxes !== null) {
		onClickListenerCheckboxes(bookArchivesCheckboxes, 'book-archives', bookArchivesSelectAllCheckbox);
		bookArchivesSelectAllCheckbox.addEventListener('click', () => {
			checkAll(bookArchivesSelectAllCheckbox, bookArchivesCheckboxes);
		});
	}
}

// Helpers
function onClickListenerCheckboxes(checkboxArray, checkboxesList, parentCheckbox) {
	parentCheckbox.checked = checkboxArray.length === getCheckedCheckboxesFor(checkboxArray).length;

	const copyrightYearsCheckboxesList = document.querySelector('#copyright-years-list');
	const bookArchivesCheckboxeList = document.querySelector('#book-archives-list');
	const list = checkboxesList === 'copyright-years' ? copyrightYearsCheckboxesList : bookArchivesCheckboxeList;

	list.addEventListener('click', () => {
		for (const item of Array.from(checkboxArray)) {
			if (item.checked === false) {
				parentCheckbox.checked = false;
			} else {
				item.checked = true;
			}
			parentCheckbox.checked = checkboxArray.length === getCheckedCheckboxesFor(checkboxArray).length;
		}
	});
}

function getCheckedCheckboxesFor(elm) {
	const checkboxesArray = [];
	for (const item of Array.from(elm)) {
		if (item.checked) {
			checkboxesArray.push(item);
		}
	}
	return checkboxesArray;
}

function checkAll(element, checkboxes) {
	for (const item of Array.from(checkboxes)) {
		item.checked = (item.type === 'checkbox' && element.checked);
	}
}

function init() {
	addCopyrightCheckboxClickListeners();
	addBookArchivesCheckboxClickListeners();
}

export default {init};
